<template>
  <div id="DocumentLimitTransaction">
    <div v-if="isLoading" style="width: 100%; height: 100%; position: absolute; z-index: 1;"></div>
    <div id="DocumentLimitTransactionTerms" class="terms" ref="capture">
      <h3 class="document-title">{{ pageTitle }}</h3>
      <DocumentLimitTransactionInformation/>
      <v-collapse-group>
        <v-collapse-wrapper ref="CreditorInformation" @onStatusChange="collapse">
          <div class="header" v-collapse-toggle>
            <DocumentLimitTransactionButton :isComplete="isComplete" :title="'채권자 정보'" :isCollapse="isCollapse"/>
          </div>
          <div class="my-content" v-collapse-content>
            <DocumentLimitTransactionCreditorInformation @complete="complete1()" @cancel="isComplete=false" ref="step1"/>
          </div>
        </v-collapse-wrapper>
        <v-collapse-wrapper ref="DebtorInformation" @onStatusChange="collapse1">
          <div class="header" v-collapse-toggle>
            <DocumentLimitTransactionButton :isComplete="isComplete1" :title="'대출자 정보'" :isCollapse="isCollapse1"/>
          </div>
          <div class="my-content" v-collapse-content>
            <DocumentLimitTransactionDebtorInformation @complete="complete1()" @cancel="isComplete1=false" ref="step1"/>
          </div>
        </v-collapse-wrapper>
        <v-collapse-wrapper ref="LoanInformation" @onStatusChange="collapse2">
          <div class="header" v-collapse-toggle>
            <DocumentLimitTransactionButton :isComplete="isComplete21&isComplete22" :title="'대출 정보'" :isCollapse="isCollapse2"/>
          </div>
          <div class="my-content" v-collapse-content>
            <DocumentLimitTransactionLoanInformation @complete="complete21()" @cancel="isComplete21=false" ref="step21"/>
            <DocumentLimitTransactionInterestRate @complete="complete22()" @cancel="isComplete22=false" ref="step22" :loan="loan" v-if="loan"/>
          </div>
        </v-collapse-wrapper>
        <v-collapse-wrapper ref="creditInquiryTerm" @onStatusChange="isCollapseCreditInquiryTerm=$event.status">
          <div class="header" v-collapse-toggle>
            <DocumentLimitTransactionButton :isComplete="isCompleteCreditInquiryTerm" title="개인(신용)정보 조회 동의서" :isCollapse="isCollapseCreditInquiryTerm"/>
          </div>
          <div class="my-content" v-collapse-content>
            <CreditInquiryTerm @complete="isCompleteCreditInquiryTerm=true" @cancel="isCompleteCreditInquiryTerm=false" ref="creditInquiryTerm" />
          </div>
        </v-collapse-wrapper>
        <v-collapse-wrapper ref="TermsAgrees" @onStatusChange="collapse3">
          <div class="header" v-collapse-toggle>
            <DocumentLimitTransactionButton :isComplete="isComplete31&isComplete32" :title="'여신한도거래 약관 동의'" :isCollapse="isCollapse3"/>
          </div>
          <div class="my-content" v-collapse-content>
            <DocumentLimitTransactionNormalTerms ref="NormalTerms"/>
            <DocumentLimitTransactionSpecialTerms :loan="loan"/>
            <DocumentLimitTransactionTransferOfBondTerms/>
            <DocumentLimitTransactionAgrees @complete="complete31()" @cancel="isComplete31=false" ref="step31"/>
            <DocumentLimitTransactionSign @complete="complete32()" @cancel="isComplete32=false" @setSignature="setSignature" ref="step32"/>
          </div>
        </v-collapse-wrapper>
      </v-collapse-group>
    </div>
    <div class="complete">
      <button
        v-ripple
        type="button"
        @click="next"
        :class="{'active':!isLoading && isCompleted}">
        다음
        <v-progress-circular
          v-if="isLoading"
          style="padding-left: 15px;"
          size="24"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </button>
    </div>
  </div>
</template>

<script>
import DocumentLimitTransactionButton from './components/DocumentLimitTransactionButton'
import DocumentLimitTransactionInformation from './components/DocumentLimitTransactionInformation'
import DocumentLimitTransactionCreditorInformation from './components/DocumentLimitTransactionCreditorInformation'
import DocumentLimitTransactionDebtorInformation from './components/DocumentLimitTransactionDebtorInformation'
import DocumentLimitTransactionLoanInformation from './components/DocumentLimitTransactionLoanInformation'
import DocumentLimitTransactionInterestRate from './components/DocumentLimitTransactionInterestRate'
import DocumentLimitTransactionNormalTerms from './components/DocumentLimitTransactionNormalTerms'
import DocumentLimitTransactionSpecialTerms from './components/DocumentLimitTransactionSpecialTerms'
import DocumentLimitTransactionTransferOfBondTerms from './components/DocumentLimitTransactionTransferOfBondTerms'
import DocumentLimitTransactionAgrees from './components/DocumentLimitTransactionAgrees'
import DocumentLimitTransactionSign from './components/DocumentLimitTransactionSign'
import CreditInquiryTerm from './components/limit-transaction/CreditInquiryTerm.vue'

import { sleep } from '@/util'

import { mapActions, mapGetters } from 'vuex'

import html2canvas from 'html2canvas'

let self

export default {
  name: 'DocumentLimitTransaction',
  components: {
    DocumentLimitTransactionButton,
    DocumentLimitTransactionInformation,
    DocumentLimitTransactionCreditorInformation,
    DocumentLimitTransactionDebtorInformation,
    DocumentLimitTransactionLoanInformation,
    DocumentLimitTransactionInterestRate,
    DocumentLimitTransactionNormalTerms,
    DocumentLimitTransactionSpecialTerms,
    DocumentLimitTransactionTransferOfBondTerms,
    DocumentLimitTransactionAgrees,
    DocumentLimitTransactionSign,
    CreditInquiryTerm,
  },
  chimera: {
    getCurrentContract() { return { url: '/contracts/current/', method: 'get' } },
    getCurrentLoan() { return { url: '/loans/current/', method: 'get' } },
    getTerm() { return { url: '/contracts/terms/code/', method: 'get', params: { code: 'LIMIT_TRANSACTION' } } },
  },
  async created() {
    // Variable Section
    self = this

    // Function Section
    let reject = async function (reason) {
      alert('문제가 발생했습니다.' + reason + '고객센터 1811-2807로 문의주세요.')
    }

    // Get contract
    await self.getCurrentContract.fetch()
    self.contract = self.getCurrentContract.data
    if (!self.contract) { reject('계약이 존재하지 않습니다.'); return }

    // Get offer
    await self.getCurrentLoan.fetch()
    self.offer = self.getCurrentLoan.data.offer
    if (!self.offer) { reject('제안이 존재하지 않습니다.'); return }

    // Get term
    await self.getTerm.fetch()
    self.term = self.getTerm.data
  },
  data: function () {
    return {
      user: null,
      offer: null,
      contract: null,
      term: null,
      subscription: null,
      isLoading: false,
      isComplete: true,
      isComplete1: false,
      isComplete21: false,
      isComplete22: false,
      isComplete31: false,
      isComplete32: false,
      isCompleteCreditInquiryTerm: false,
      isCollapse: false,
      isCollapse1: false,
      isCollapse2: false,
      isCollapse3: false,
      isCollapseCreditInquiryTerm: false,
      signature: null,
    }
  },
  computed: {
    isCompleted() {
      return this.isComplete1 && this.isComplete21 && this.isComplete22 && this.isCompleteCreditInquiryTerm && this.isComplete31 && this.isComplete32
    },
    ...mapGetters('loan', {
      loan: 'getLoanData'
    }),
    pageTitle() {
      if (!this.loan) {
        return ''
      }
      const title = this.loan.type === 'marketing' ? '마케팅론 여신거래계약서' : '여신한도거래계약서'
      this.$store.commit('ui/headerTitle', title)
      return title
    },
  },
  watch: {
    isCompleteCreditInquiryTerm(value) {
      if (value === true) {
        this.close('creditInquiryTerm')
        this.navigateNextStep()
      }
    }
  },
  methods: {
    ...mapActions('loan', {
      setAgreementData: 'setAgreementData',
    }),
    ...mapActions('loading', {
      setIsLoading: 'setIsLoading'
    }),
    open(refName) {
      if (this.$refs && this.$refs[refName]) {
        this.$refs[refName].open()
      }
    },
    navigateNextStep() {
      // 다음 단계로 자동 이동
      if (!this.isComplete1) {
        this.open('DebtorInformation')
        this.$refs.step1.$el.scrollIntoView({ behavior: 'smooth' })
      } else if (!(this.isComplete21 && this.isComplete22)) {
        this.open('LoanInformation')
        this.$refs.step21.$el.scrollIntoView({ behavior: 'smooth' })
        this.$refs.step21.$refs.first_input.$refs.input.focus()
      } else if (!this.isCompleteCreditInquiryTerm) {
        this.open('creditInquiryTerm')
        this.$refs.creditInquiryTerm.$el.scrollIntoView({ behavior: 'smooth' })
      } else if (!(this.isComplete31 && this.isComplete32)) {
        this.open('TermsAgrees')
        this.$refs.step31.$el.scrollIntoView({ behavior: 'smooth' })
      }
    },
    close(refName) {
      this.$refs[refName].close()
    },
    checkAll() {
      if (!this.isCompleted) {
        if (!this.isComplete1) {
          alert('확인 버튼을 클릭해주세요.')
          this.open('DebtorInformation')
        } else if (!(this.isComplete21 && this.isComplete22)) {
          alert('만기일, 한도 금액, 이율을 작성 및 확인 버튼을 클릭해주세요.')
          this.open('LoanInformation')
        } else if (!this.isCompleteCreditInquiryTerm) {
          alert('개인(신용)정보 조회 동의서에 동의 버튼을 클릭해주세요.')
          this.open('creditInquiryTerm')
        } else if (!(this.isComplete31 && this.isComplete32)) {
          alert('확인함 버튼 클릭 및 서명해주세요.')
          this.open('TermsAgrees')
        }
      } else {
        return true
      }
    },
    complete1() {
      this.isComplete1 = true
      this.close('DebtorInformation')
      this.navigateNextStep()
    },
    complete21() {
      this.isComplete21 = true
      if (this.isComplete21 && this.isComplete22) { this.complete2() }
    },
    complete22() {
      this.isComplete22 = true
      if (this.isComplete21 && this.isComplete22) { this.complete2() }
    },
    complete2() {
      this.close('LoanInformation')
      this.navigateNextStep()
    },
    complete31() {
      this.isComplete31 = true
      if (this.isComplete31 && this.isComplete32) { this.complete3() }
    },
    complete32() {
      this.isComplete32 = true
      if (this.isComplete31 && this.isComplete32) { this.complete3() }
    },
    complete3() {
      this.close('CreditorInformation')
      this.close('TermsAgrees')
      this.navigateNextStep()
    },
    async next() {
      if (this.isLoading) {
        return
      }
      if (!self.checkAll()) {
        return
      }

      try {
        self.isLoading = true
        this.setIsLoading(true)

        let image = await self.capture()
        this.setAgreementData({
          contract: self.contract.uuid,
          term: self.term.uuid,
          offer: self.offer.uuid,
          is_agreed: true,
          signature: self.signature,
          image: image
        })

        self.$router.push({ name: 'loan/confirm' })
      } catch (e) {
        await this.$swal.fire({
          html: `<p class="custom-alert__text">
            <p style="font-weight: 700">계약서 저장에 실패했습니다. 다시 시도해주세요.</p>
            <p style="font-size: 14px">
              문제가 지속될 시 고객센터로 문의주세요.
            </p>
          </p>`,
          confirmButtonText: '확인',
          customClass: { container: 'custom-alert2', actions: 'single' }
        })

        throw e
      } finally {
        this.isLoading = false
        this.setIsLoading(false)
      }
    },
    async capture() {
      this.open('CreditorInformation')
      this.open('DebtorInformation')
      this.open('LoanInformation')
      this.open('creditInquiryTerm')
      this.open('TermsAgrees')
      this.$refs.NormalTerms.open('NormalTerms')

      await sleep(1500)

      const element = this.$refs.capture
      const canvas = await html2canvas(element, {
        x: 0,
        y: 0,
        scale: 1
      })

      // 에러 테스트용
      // if (canvas) { throw Error('123') }

      const blob = await new Promise((resolve) => canvas.toBlob(resolve))

      // 계약서 미리보기 테스트용
      // this.$swal.fire({
      //   html: `<div style='height: 500px; overflow:scroll'><p>test view</p><img src='${window.URL.createObjectURL(blob)}' /></div>`,
      // })

      return blob
    },
    collapse(obj) {
      this.isCollapse = obj.status
    },
    collapse1(obj) {
      this.isCollapse1 = obj.status
    },
    collapse2(obj) {
      this.isCollapse2 = obj.status
    },
    collapse3(obj) {
      this.isCollapse3 = obj.status
    },
    setSignature(data) {
      this.signature = data
    }
  },
  mounted() {
    this.open('DebtorInformation')
  }
}
</script>

<style lang="scss" scoped>
   #DocumentLimitTransaction {
    background-color: #ffffff;
    display: block;
    float: left;
    box-sizing: border-box;
    width: 100%;
    .document-title {
      font-weight: 900;
      text-align: center;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .terms {
      padding-bottom: 30px;
      box-sizing: border-box;
    }
    .complete {
      height: 68px;
      button {
        position: fixed;
        bottom: 0;
        width: 100%;
        max-width: 42.5rem;
        height: 68px;
        font-weight: 900;
        font-size: 22px;
        text-align: center;
        color: #727d8c;
        background-color: #e3ecf6;
        z-index: 999;
        &.active {
          color: #ffffff;
          background-color: #1baaf1;
        }
      }
    }
  }
</style>
